<template>
  <el-dialog title="修改信息" :visible.sync="visible" width="800px" custom-class="my-dialog-template modifyStaffDialog" :close-on-click-modal="false">
    <el-form :model="user" :rules="userules" class="my-form-template staffform" ref="modifyStaffRef" label-width="110px" v-loading="loading">
      <el-form-item label="真实姓名" prop="name" class="less">
        <el-input v-model.trim="user.name" :maxlength="12" placeholder="真实姓名"></el-input>
      </el-form-item>
      <el-form-item label="所属团队" prop="mechanName" class="less">
        {{ user.mechanName }}
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile" class="less" :rules="isEditMobile ? rules.tel() : { required: false }">
        <el-input class="numberInput" @change="isEditMobile = true" v-model.trim="user.mobile" :maxlength="11" placeholder="手机号码"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCardNo" class="less" :rules="[isEditCardNo ? $tools.formRule.idCard('身份证号格式有误') : {}]">
        <el-input class="numberInput" v-model.trim="user.idCardNo" @change="isEditCardNo = true" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="执业证号" prop="certificateNo" class="less">
        <el-input class="numberInput" v-model.trim="user.certificateNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="登录账号" prop="account" class="less">
        <el-input class="numberInput" v-model.trim="user.account" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" class="less" v-if="flag" key="password" style="margin-bottom: 10px">
        <el-input v-model.trim="user.password" type="password" autocomplete="new-password" placeholder="登录密码"></el-input>
      </el-form-item>
      <el-form-item label="确认登录密码" prop="agpassword" class="less" v-if="flag" label-width="180px" key="agpassword" style="margin-bottom: 10px">
        <el-input v-model.trim="user.agpassword" type="password" autocomplete="new-password" placeholder="确认密码"></el-input>
      </el-form-item>
      <div class="text3" v-if="flag">注：新密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
      <el-form-item class="less" v-if="!flag">
        <el-button type="primary" class="mdBtn" plain @click="flag = true">修改密码</el-button>
      </el-form-item>

      <el-form-item label="推荐人" prop="recommendId" class="less">
        <el-select v-model="user.recommendId" filterable placeholder="请选择" clearable>
          <el-option v-for="item in staffList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="user.type != 1" label="费率模板" prop="commissonTemplateCode" class="less">
        <el-select v-model="user.commissonTemplateCode" filterable placeholder="请选择">
          <el-option v-for="item in feeTemplateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="user.type != 1" label="产品模板" class="less" prop="productTemplateCode" style="width: 55%">
        <el-select v-model="user.productTemplateCode" placeholder="请选择产品模板" filterable>
          <el-option :label="item.name" :value="item.code" v-for="(item, index) in allTemplate" :key="index"></el-option>
        </el-select>
        <el-button class="viewBtn" type="text" @click="viewProduct()">查看产品</el-button>
      </el-form-item>
      <el-form-item label="状态" class="less">
        <el-switch v-model="user.useStatus" active-color="#FD9201" active-text="启用" active-value="1" inactive-text="禁用" inactive-value="0"> </el-switch>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button
        type="warning"
        plain
        @click="
          visible = false;
          flag = false;
        "
        >取消</el-button
      >
      <el-button type="warning" class="bgBtn" @click="handleEdit()">保存</el-button>
    </div>
    <viewProduct ref="viewProductRef"></viewProduct>
  </el-dialog>
</template>
<script>
import viewProduct from './viewProduct.vue';
import { ruleTool } from '@/api/mixins';
export default {
  mixins: [ruleTool],
  data: () => ({
    level: '',
    loading: false,
    data: '',
    templateId: '', // 模板id
    flag: false,
    visible: false,
    allTemplate: [], // 产品模板列表
    staffList: [], // 保存员工数据
    isEditMobile: false,
    isEditCardNo: false,
    user: {
      name: '',
      useStatus: '1',
      idCardNo: '',
      certificateNo: '',
      mobile: '',
      password: '',
      agpassword: '',
      account: '',
      mechanName: '', // 所属机构
      deptName: '',
      productTemplateCode: ''
    },
    feeTemplateList: [], // 产品模板列表
    userules: {
      name: [
        {
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        },
        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' }
      ],
      agpassword: [
        {
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        },
        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' }
      ],
      account: [
        {
          required: true,
          message: '请输入登录账号',
          trigger: 'blur'
        }
      ],
      productTemplateCode: [
        {
          required: true,
          message: '请选择产品模板',
          trigger: 'change'
        }
      ]
    }
  }),
  components: { viewProduct },
  methods: {
    // 查询所有费率模板
    getFeeTemplate() {
      this.$http({
        url: '/master/commissonTemplate/read/all',
        type: 'PUT',
        params: {
          type: '2',
          mechanId: this.user.mechanId
        }
      }).then(res => {
        this.feeTemplateList = res.data;
      });
    },
    open(data = {}) {
      var userinfo = this.$tools.getLocal('userinfo');
      this.level = userinfo.level;
      this.isEditMobile = false;
      this.isEditCardNo = false;
      data.password = '';
      this.data = data;
      this.user = JSON.parse(JSON.stringify(data));
      console.log(this.user);
      this.flag = false;
      this.visible = true;
      this.getFeeTemplate();
      this.getAllTemplate();
      this.getStaffList();
      this.$nextTick(() => {
        this.$refs.modifyStaffRef && this.$refs.modifyStaffRef.clearValidate();
      });
    },
    // 获取员工列表
    getStaffList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {}
      }).then(data => {
        this.staffList = data.data;
      });
    },
    // 查询所有模板
    getAllTemplate() {
      this.$http({
        url: '/master/productTemplate/read/all',
        type: 'PUT',
        params: {
          mechanId: this.user.mechanId
        }
      }).then(res => {
        this.allTemplate = res.data;
      });
    },
    // 查看产品
    viewProduct() {
      this.allTemplate.map(item => {
        if (item.code == this.user.productTemplateCode) {
          this.templateId = item.id;
        }
      });
      this.$refs.viewProductRef.open(this.templateId);
    },
    handleEdit() {
      this.$refs['modifyStaffRef'].validate(valid => {
        if (valid) {
          if (!this.flag) {
            this.user.password = '';
            this.updateMechanSubAccount();
          } else {
            if (this.user.password == this.user.agpassword) {
              this.updateMechanSubAccount();
            } else {
              this.$message.error('两次密码输入不一致');
              return;
            }
          }
        } else {
          this.$message.error('请输入信息');
        }
      });
    },
    //更新修改子机构
    updateMechanSubAccount() {
      this.loading = true;
      // 为了处理后端设计bug，这里要清除mechanName再提交，不然储存的信息有误
      this.user.mechanName = '';
      this.$http({
        url: '/master/subAccount/updateMechanUser',
        type: 'put',
        params: this.user
      })
        .then(data => {
          this.loading = false;
          if (data.httpCode == 200) {
            this.flag = false;
            this.$message.success('修改成功');
            this.visible = false;
            this.$emit('reload');
          }
        })
        .catch(e => {
          this.loading = false;
          // 为了处理后端设计bug，这里要更新失败要重新给mechanName赋值，不然无法再次提交
          this.user.mechanName = JSON.parse(JSON.stringify(this.data)).mechanName;
        });
    }
  }
};
</script>
<style lang="scss">
.modifyStaffDialog {
  .staffform {
    margin-bottom: 10px;
    .el-form-item {
      .el-form-item__content {
        .el-cascader {
          line-height: 32px;
        }
      }
    }
    .el-form-item {
      margin-bottom: 30px;
    }
    .el-form-item.is-error .el-input__validateIcon {
      display: none;
    }
    .el-form-item .el-input__validateIcon {
      display: none;
    }
    .el-select {
      width: calc(100% - 80px) !important;
    }
    .viewBtn {
      margin-left: 20px;
    }
    .el-switch {
      width: auto;
    }
    .mdBtn {
      width: 100px;
      height: 32px;
      padding: 0;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
    .text3 {
      text-align: left;
      margin-bottom: 30px;
      margin-left: 15px;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
